import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	startNodeLabel: {
		id: 'accessible-workflow-diagram.diagram.start-node.start-node-label',
		defaultMessage: 'START',
		description: 'Capitalised label for the start node in the workflow.',
	},
});
